import { DatePipe } from "@angular/common";

export function getDayDatePartFromDateObject(date: Date): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

// TODO: Most functions in this file are redundant, Angular already knows to do this through the date pipe
export function formatDate(
  input: Date | string | null | undefined,
  out: "yyyy-MM-dd" | "dd.MM.yyyy" = "yyyy-MM-dd",
): string {
  const date = input instanceof Date ? input : parseDateString(input);
  if (!date) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return out === "dd.MM.yyyy"
    ? `${day}.${month}.${year}`
    : `${year}-${month}-${day}`;
}

function parseDateString(s: string | null | undefined): Date | null {
  if (!s) return null;
  const str = s.trim();

  // DD/MM/YYYY
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
    const [dd, mm, yyyy] = str.split("/").map(Number);
    return makeValidDate(yyyy, mm, dd);
  }

  // DD=MM-YYYY
  if (/^\d{2}-\d{2}-\{d{4}$/.test(str)) {
    const [dd, mm, yyyy] = str.split("-").map(Number);
    return makeValidDate(yyyy, mm, dd);
  }

  // DD.MM.YYYY
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(str)) {
    const [dd, mm, yyyy] = str.split(".").map(Number);
    return makeValidDate(yyyy, mm, dd);
  }

  // ISO (YYYY-MM-DD)
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
  }

  return null;
}

function makeValidDate(yyyy: number, mm: number, dd: number): Date | null {
  const d = new Date(yyyy, mm - 1, dd);
  return d.getFullYear() === yyyy &&
    d.getMonth() === mm - 1 &&
    d.getDate() == dd
    ? d
    : null;
}

export function dateToString(date: Date | null | undefined): string | null {
  if (!date) {
    return null;
  }
  const datePipe = new DatePipe("en-US");
  return datePipe.transform(date, "yyyy-MM-dd HH:mm:ss");
}

export function convertAndFormatDate(
  date: Date | string | null | undefined,
): string | null {
  if (date) {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    return new Date(date).toLocaleDateString("en-GB", options);
  }
  return null;
}

export function isFutureDay(date: Date | string): boolean {
  const inputDate = new Date(date);
  if (isNaN(inputDate.getTime())) {
    throw new Error("Invalid date input");
  }

  const today = new Date();
  const inputStart = new Date(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate(),
  );
  const todayStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );

  return inputStart > todayStart;
}

export function timeAgo(date: Date): string {
  const now = new Date().getTime();
  const diff = Math.max(0, now - date.getTime());
  const mins = Math.floor(diff / 60000);

  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min${mins === 1 ? "" : "s"} ago`;

  const hours = Math.floor(mins / 60);

  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;

  const days = Math.floor(hours / 24);

  return `${days} day${days === 1 ? "" : "s"} ago`;
}
